module.exports = __webpack_public_path__ + "img/index-desc-1-pic.d975220c.png";